module.exports = __webpack_public_path__ + "img/01產品發佈.d318f684.jpg";